/**
 * 文件路径生成工具
 * 用于在前端预生成唯一的文件存储路径
 */

/**
 * 生成唯一的文件路径
 * @param fileType 文件类型
 * @param fileName 原始文件名
 * @param userId 用户ID（可选）
 * @returns 生成的文件路径
 */
export const generateUniqueFilePath = (
  fileType: 'document' | 'avatar' | 'voice' | 'other',
  fileName: string,
  userId?: string
): string => {
  // 获取文件扩展名
  const fileExtension = fileName.split('.').pop() || '';
  
  // 生成时间戳
  const timestamp = Date.now();
  
  // 生成随机字符串
  const randomStr = Math.random().toString(36).substring(2, 8);
  
  // 构建路径
  const datePath = new Date().toISOString().slice(0, 10).replace(/-/g, '/');
  const uniqueFileName = `${timestamp}_${randomStr}.${fileExtension}`;
  
  if (userId) {
    return `${fileType}/${datePath}/${userId}/${uniqueFileName}`;
  } else {
    return `${fileType}/${datePath}/${uniqueFileName}`;
  }
};

/**
 * 生成语音文件路径
 * @param userId 用户ID（可选）
 * @returns 生成的语音文件路径
 */
export const generateVoiceFilePath = (userId?: string): string => {
  return generateUniqueFilePath('voice', 'recording.mp3', userId);
};

/**
 * 从文件路径提取文件名
 * @param filePath 文件路径
 * @returns 文件名
 */
export const extractFileNameFromPath = (filePath: string): string => {
  return filePath.split('/').pop() || 'unknown';
};

/**
 * 验证文件路径格式
 * @param filePath 文件路径
 * @returns 是否有效
 */
export const isValidFilePath = (filePath: string): boolean => {
  // 基本格式验证：fileType/date/[userId/]filename
  const pathParts = filePath.split('/');
  return pathParts.length >= 3 && pathParts.length <= 4;
};